import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"30px"},
  class: "pi pi-clock p-mt-3"
}, null, -1)
const _hoisted_2 = {
  class: "p-text-bold",
  style: {"font-size":"20px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomRadioButton = _resolveComponent("CustomRadioButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    "content-class": "p-d-flex p-jc-around p-flex-wrap p-pt-3",
    header: _ctx.$t('activity.chooseSubscription'),
    visible: _ctx.modelValue,
    "content-style": "max-width: 500px"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false))),
        class: "p-button-success",
        label: _ctx.$t('cancel')
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        disabled: !_ctx.subscription,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit'))),
        label: _ctx.$t('activity.subscribe.process')
      }, null, 8, ["disabled", "label"])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subscriptions, (sub, index) => {
        return (_openBlock(), _createBlock(_component_CustomRadioButton, {
          key: index,
          value: sub.id,
          name: "subscriptions",
          "onUpdate:modelValue": ($event: any) => (_ctx.$emit('update:subscription', sub))
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createElementVNode("div", null, _toDisplayString(sub.duration) + " " + _toDisplayString(_ctx.$t(`month`).toLowerCase()), 1),
            _createElementVNode("div", _hoisted_2, _toDisplayString(sub.cost) + " " + _toDisplayString(_ctx.subscriptions[0].currency), 1)
          ]),
          _: 2
        }, 1032, ["value", "onUpdate:modelValue"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["header", "visible"]))
}